import styled from 'styled-components';
import mainColors from '../../main-colors';
import sizeStandards from '../../size-standards';

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  .modal-backdrop {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.6);
  }

  .modal-content {
    position: relative;
    background: ${`linear-gradient(to top, ${mainColors.addOpacityTo(mainColors.dark_background, 0.8)}, ${mainColors.main_color_rgba(1)})`};
    box-shadow: 0px 0px 20px 1px #ffffff;
    color: ${mainColors.text_color};
    padding: 20px;
    margin: 20px;
    border-radius: 8px;
    z-index: 999;
    max-height: 90dvh;
  }

  .close-button {
    position: absolute;
    color: ${mainColors.text_color};
    top: 4px;
    right: 4px;
    font-size: ${sizeStandards.font.XL}px;
    background: none;
    border: none;
    cursor: pointer;
  }

  .confirmation-box {
    text-align: center;

    .confirmation-text {
      max-width: 500px;
      width: 100%;
    }
  }

  .modal-cancel-btn {
    background: transparent;
    &:hover {
      background-color: ${mainColors.main_color};
    }
  }
`;

export default ModalWrapper;
